module.exports = __webpack_public_path__ + "static/media/24UHCHR13.9df5d396.jpg";